export function initFAQAccordion() {
	const roots = document.querySelectorAll<HTMLElement>("[data-faq-root]");
	roots.forEach((root) => wireRoot(root));
}

function wireRoot(root: HTMLElement) {
	root.addEventListener("click", (e) => {
		const btn = (e.target as HTMLElement).closest<HTMLButtonElement>(".faq-question");
		if (!btn || !root.contains(btn)) return;

		toggleInRoot(root, btn);
	});
}

function toggleInRoot(root: HTMLElement, button: HTMLButtonElement) {
	const controlsId = button.getAttribute("aria-controls");
	if (!controlsId) return;

	const answer = root.querySelector<HTMLElement>(`#${CSS.escape(controlsId)}`);
	if (!answer) return;

	const icon = button.querySelector<HTMLElement>(".faq-icon");
	const isExpanded = button.getAttribute("aria-expanded") === "true";

	closeAllInRoot(root);

	if (!isExpanded) {
		button.setAttribute("aria-expanded", "true");
		answer.setAttribute("aria-hidden", "false");
		answer.classList.remove("grid-rows-[0fr]");
		answer.classList.add("pl-10", "pt-4");
		answer.classList.add("grid-rows-[1fr]");
		if (icon) icon.textContent = "-";
	}
}

function closeAllInRoot(root: HTMLElement) {
	root.querySelectorAll<HTMLElement>(".faq-question").forEach((q) => q.setAttribute("aria-expanded", "false"));
	root.querySelectorAll<HTMLElement>(".faq-answer").forEach((a) => {
		a.setAttribute("aria-hidden", "true");
		a.classList.remove("grid-rows-[1fr]");
		a.classList.remove("pl-10", "pt-4");
		a.classList.add("grid-rows-[0fr]");
	});
	root.querySelectorAll<HTMLElement>(".faq-icon").forEach((i) => (i.textContent = "+"));
}
